import { useEffect, useState } from "react";
import { getDomainConfig } from "../../config/config";
import paypalLogo from "./paypal.png";
import { useTranslation } from "react-i18next";
import styles from "./Paypal.module.scss"

const Paypal = (props) => {
  const config = getDomainConfig();

  const [loadState, setLoadState] = useState({ loading: false, loaded: false });

  useEffect(() => {
    if (!loadState.loading && !loadState.loaded) {
      setLoadState({ loading: true, loaded: false });
      const scriptPaypal = document.createElement("script");
      scriptPaypal.setAttribute("id", "external");
      scriptPaypal.setAttribute("type", "text/javascript");
      scriptPaypal.setAttribute("defer", "defer");
      scriptPaypal.setAttribute("crossorigin", "anonymous");
      scriptPaypal.setAttribute("data-namespace", "paypal_sdk");
      scriptPaypal.src = config.paypalScript;

      scriptPaypal.addEventListener("load", () =>
        setLoadState({ loading: false, loaded: true })
      );

      document.body.appendChild(scriptPaypal);
    }
  }, [loadState, config]);

  const { t } = useTranslation("common");
  return (
    <div
      id="paypal-form"
      className="tabs__content tabs__content--hidden tabs__content--checkout tabs__content--paypal"
    >
      <div className="top-content">
        <div id="paypal-logo">
          <div className="text">
            <img
              src={paypalLogo}
              className={props.styles.payment_logo}
              alt="paypal"
            />
            <div
              data-pp-message
              id="data-pp-message"
              data-pp-placement="payment"
              data-pp-amount={props.amountToPay ? props.amountToPay : ""}
              data-pp-style-layout="text"
              data-pp-style-logo-type="inline"
              data-pp-style-text-size="16"
            ></div>
          </div>
          <div className={props.styles.paypalWrapper}>
            <p className={props.styles.userMessage}>
              <span className={props.styles.paypalPleaseNote}>
                {t("please-note")}{" "}
              </span>
              {t("you")}{" "}
              <span className={props.styles.paypalMust}>{t("must")} </span>
              {t("use-same-email")}
            </p>
          </div>
          {props.paymentFailed && <p id="payment-error" className={styles.error}>{t('payment-failed-try-again')}</p>}
          {props.isCro1381 && <p>{t("to-continue-paypal")}</p>}
        </div>
      </div>
    </div>
  );
};

export default Paypal;
